export enum $scanAudit {
  _id = '_id',
  audits = 'audits',
  scanId = 'scanId',
  schemaVersion = 'schemaVersion',
}
